/* HLT お問い合わせチャット: 見た目はチャット、送信は Shopify contact フォーム
 * カスタマイザーのセクション再描画(shopify:section:load)後も再初期化する。 */
(function () {
  function init() {
  var form = document.querySelector('[data-hlt-chat-form]');
  var input = document.querySelector('[data-hlt-chat-input]');
  var send = document.querySelector('[data-hlt-chat-send]');
  var msgs = document.querySelector('[data-hlt-chat-msgs]');
  var contactForm = document.getElementById('hlt-contact-form');
  var emailField = document.querySelector('[data-hlt-contact-email]');
  var bodyField = document.querySelector('[data-hlt-contact-body]');
  if (!form || !input || !msgs || !contactForm) return;
  if (form.dataset.hltBound) return;
  form.dataset.hltBound = '1';

  var settings = {
    emailPrompt: msgs.dataset.emailPrompt || 'Thanks for your message! Please enter your email address so our staff can reply to you.',
    sentNote: msgs.dataset.sentNote || 'Thank you! Your message has been sent. Our staff will reply to your email within 48 hours.'
  };

  function bubbleUser(text) {
    var wrap = document.createElement('div');
    wrap.className = 'flex justify-end';
    var b = document.createElement('div');
    b.className = 'max-w-[80%] bg-accent text-white rounded-2xl rounded-br-md px-4 py-3 text-sm whitespace-pre-line';
    b.textContent = text;
    wrap.appendChild(b);
    msgs.appendChild(wrap);
    wrap.scrollIntoView({ block: 'end', behavior: 'smooth' });
  }

  function bubbleBot(node) {
    var wrap = document.createElement('div');
    wrap.className = 'flex items-start gap-3';
    var av = document.createElement('div');
    av.className = 'w-8 h-8 rounded-full bg-accent/15 border border-accent/30 flex items-center justify-center shrink-0';
    av.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-headphones w-4 h-4 text-accent"><path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-9a9 9 0 0 1 18 0v9a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"></path></svg>';
    var b = document.createElement('div');
    b.className = 'max-w-[80%] bg-white/5 border border-white/10 rounded-2xl rounded-bl-md px-4 py-3 text-sm text-white/80';
    if (typeof node === 'string') { b.textContent = node; } else { b.appendChild(node); }
    wrap.appendChild(av);
    wrap.appendChild(b);
    msgs.appendChild(wrap);
    wrap.scrollIntoView({ block: 'end', behavior: 'smooth' });
  }

  function updateSend() {
    if (!send) return;
    if (input.value.trim()) send.removeAttribute('disabled');
    else send.setAttribute('disabled', '');
  }
  input.addEventListener('input', updateSend);
  updateSend();

  var pendingBody = '';

  function askEmail() {
    var box = document.createElement('div');
    var p = document.createElement('p');
    p.textContent = settings.emailPrompt;
    p.className = 'mb-2';
    var row = document.createElement('div');
    row.className = 'flex gap-2 mt-2';
    var em = document.createElement('input');
    em.type = 'email';
    em.required = true;
    em.placeholder = 'your@email.com';
    em.className = 'flex-1 bg-white/10 border border-white/20 rounded-lg px-3 py-2 text-sm text-white placeholder:text-white/30 focus:outline-none focus:border-accent/60';
    var ok = document.createElement('button');
    ok.type = 'button';
    ok.textContent = 'Send';
    ok.className = 'px-4 py-2 bg-accent hover:bg-accent/90 text-white text-sm rounded-lg';
    ok.addEventListener('click', function () {
      if (!em.value || em.validity && !em.validity.valid) { em.focus(); return; }
      emailField.value = em.value;
      submitContact();
    });
    em.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); ok.click(); }
    });
    row.appendChild(em);
    row.appendChild(ok);
    box.appendChild(p);
    box.appendChild(row);
    bubbleBot(box);
    em.focus();
  }

  function submitContact() {
    bodyField.value = pendingBody;
    try { sessionStorage.setItem('hltChatSent', '1'); } catch (e) {}
    contactForm.submit();
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var text = input.value.trim();
    if (!text) return;
    pendingBody = text;
    bubbleUser(text);
    input.value = '';
    updateSend();
    if (emailField.value) submitContact();
    else askEmail();
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      form.dispatchEvent(new Event('submit', { cancelable: true }));
    }
  });

  document.querySelectorAll('[data-hlt-faq]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      input.value = btn.getAttribute('data-message') || (btn.textContent || '').trim();
      updateSend();
      input.focus();
    });
  });

  // 送信完了後(ページ再読込)の完了メッセージ
  var posted = document.querySelector('[data-hlt-posted]');
  var flagged = false;
  try { flagged = sessionStorage.getItem('hltChatSent') === '1'; sessionStorage.removeItem('hltChatSent'); } catch (e) {}
  if (posted || flagged) bubbleBot(settings.sentNote);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () { init(); });
})();
